import BrandAlertTemplate from "./BrandAlertTemplate.vue";

/**
 * Built-in branded alert "templates".
 *
 * A template is a media that is rendered in code (not an uploaded asset), so it
 * owns its own staging: the streamer can still edit the text/sound, but the
 * alignment and in/out transitions are locked to the values declared here.
 *
 * Each entry:
 *  - component     : the Vue component that draws the visual (no text inside)
 *  - direction     : locked text/media alignment (see AlertItem `direction`)
 *  - animationIn   : locked enter animation (animate.css name, or "" for none)
 *  - animationOut  : locked leave animation
 *  - durationMs    : how long the visual stays on screen when there is no sound
 */
export const ALERT_TEMPLATES = {
  "brand-burst": {
    component: BrandAlertTemplate,
    direction: "center",
    animationIn: "fadeIn",
    animationOut: "fadeOut",
    durationMs: 5000,
  },
};

export function getAlertTemplate(id) {
  return ALERT_TEMPLATES[id] || null;
}
